var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PreOrders',{attrs:{"loaded":_vm.loaded,"pre-orders":_vm.preOrders,"excluded-columns":_vm.excludedColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }